import script from "./popup-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./popup-layout.vue?vue&type=script&setup=true&lang=js"

import "./popup-layout.vue?vue&type=style&index=0&id=d5e6be2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5e6be2a"]])

export default __exports__